import { useEffect, useState } from 'react';

export const useDebounce = (time: number) => {
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFinished(true), time);

    return () => clearTimeout(timer);
  }, [time]);

  return finished;
};
